import { useEffect, useState, type FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import {
  TextFieldGroup,
  useInputGroupState,
  Text,
} from "@smartsuite/react-ui/lib";

import { useRootStore } from "../../../../../../stores/hooks";
import { StyledWrapper, StyledHeader } from "./styles";
import { useTranslation } from "react-i18next";

interface ConditionalGroupNameInputProps {
  value: string;

  onChangeValue: (value: string) => void;

  loopInstanceId?: number;
}

export const ConditionalGroupNameInput: FunctionComponent<ConditionalGroupNameInputProps> =
  observer(({ value, onChangeValue, loopInstanceId }) => {
    const store = useRootStore();
    const looping = store.automations.candidate.looping;
    const { t } = useTranslation();
    const defaultGroupName =
      loopInstanceId !== undefined
        ? looping.defaultGroupNameAt(loopInstanceId).groupName
        : looping.getDefaultGroupName().groupName;
    const source =
      loopInstanceId !== undefined
        ? looping.sourceAt(loopInstanceId)
        : looping.source;
    const [localValue, setLocalValue] = useState(
      () => value || defaultGroupName,
    );
    const { state, onBlur, onFocus } = useInputGroupState();

    const handleBlur = (): void => {
      if (localValue) {
        onChangeValue(localValue);
      }

      if (!localValue) {
        setLocalValue(defaultGroupName);
        onChangeValue("");
      }

      onBlur();
    };

    useEffect(() => {
      if (source && !value) {
        setLocalValue(defaultGroupName);
      }
    }, [JSON.stringify(source)]);

    return (
      <StyledWrapper>
        <StyledHeader>
          <Text weight="medium">{t("looping.group-name")}</Text>
          <Text size="xs" color="secondary">
            {t("looping.group-name-description")}
          </Text>
        </StyledHeader>
        <TextFieldGroup
          placeholder={t("general.repeat-for-each-in")}
          value={localValue}
          inputGroupClass={state}
          onFocus={onFocus}
          onBlur={handleBlur}
          onChangeValue={setLocalValue}
        />
      </StyledWrapper>
    );
  });
